import { FormEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import PDFViewer from "./PDFViewer";
import { api } from "@/utils/api";
import { toast } from "@/utils/appToast";

export function CertificationUpdater({ refetchCertifications }) {
  const { t } = useTranslation();
  const [pdfFile, setPdfFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handlePdfPreview = (e) => {
    const file = e.target.files[0];

    if (file && file.type === "application/pdf") {
      setPdfFile(file);
      setFileUrl(URL.createObjectURL(file));
    } else {
  alert(t('uploadCertificate'));
    }
  };

  const resetPDFHandler = () => {
    setPdfFile(null);
    setFileUrl(null);
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const htmlForm = e.target as HTMLFormElement;
      let certificationForm = new FormData(htmlForm);
      let fileToUpload = certificationForm.get("file") as File | null;

      // Fallback: use file from state if form didn't include it (more reliable across browsers)
      if (!fileToUpload || !(fileToUpload instanceof File) || !fileToUpload.size) {
        if (pdfFile && pdfFile.size > 0) {
          certificationForm = new FormData();
          certificationForm.append("file", pdfFile);
          fileToUpload = pdfFile;
        }
      }

      if (!fileToUpload || !(fileToUpload instanceof File) || fileToUpload.size === 0) {
        toast.error(t('pleaseSelectPdf') || 'Please select a PDF file to upload.');
        return;
      }

      await toast.promise(api.createCertification(certificationForm), {
        success: t('uploadCertificate'),
        pending: t('uploadCertificate'),
        error: t('noDataAvailableAgainstFilters'),
      });
      resetPDFHandler();
      refetchCertifications();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <form onSubmit={handleSubmit} className="uploadButton">
        <input
          id="upload"
          type="file"
          name="file"
          accept=".pdf"
          onChange={handlePdfPreview}
          required
          hidden
        />
        {pdfFile ? (
          <>
            <PDFViewer path={fileUrl} />
            <p>{pdfFile.name}</p>
            <div style={{ display: "flex", gap: 10, paddingBottom: 20 }}>
              <button
                className="theme-btn btn-style-one"
                style={
                  isLoading
                    ? { backgroundColor: "gray", cursor: "not-allowed" }
                    : { backgroundColor: "gray" }
                }
                onClick={!isLoading ? resetPDFHandler : () => {}}
              >
                {t('close')}
              </button>
              <button
                type="submit"
                disabled={isLoading}
                className="theme-btn btn-style-one"
                style={
                  isLoading
                    ? { backgroundColor: "gray", cursor: "not-allowed" }
                    : {}
                }
              >
                {t('save')}
              </button>
            </div>
          </>
        ) : (
          <>
            <label
              className="uploadButton-button ripple-effect"
              htmlFor="upload"
              style={{ width: "100%" }}
            >
              {t('uploadDocument')}
            </label>
            <span className="uploadButton-file-name"></span>
            <div className="text">{t('uploadLimit')}</div>
          </>
        )}
      </form>
    </div>
  );
}
